import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@interstate/components/Alert';
import { useIntl } from 'react-intl';
const NoDashboard = () => {
    const intl = useIntl();
    return (_jsx("div", { className: "no-dashboards-message", children: _jsx(Alert, { title: intl.formatMessage({
                id: 'logiView.noDashboardsTitle',
                defaultMessage: 'No Dashboards Available',
            }), type: "info", children: _jsx("span", { children: intl.formatMessage({
                    id: 'logiView.noDashboardsMessage',
                    defaultMessage: 'It looks like you don\'t have any dashboards '
                        + 'available. Please contact your administrator for access.',
                }) }) }) }));
};
export default NoDashboard;
